import Image from 'next/image'

const SlotFullModal = ({slotFull}) => {
  return (
    <div>
              <div
                className=" z-50 justify-center items-center md:inset-0  sm:h-full"
                id="popup-modal"
              >
                <div className="relative px-4 w-full mx-auto sm:max-w-4xl h-full md:h-auto">
                  {/* <!-- Modal content --> */}
                  <div className="relative  rounded-lg">
                    {/* <!-- Modal header --> */}
                    <div className="flex justify-end p-2">
                      <button
                        type="button"
                        onClick={slotFull}
                        className="bg-transparent text-blue hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center hover:bg-blue dark:hover:text-white"
                        data-modal-toggle="popup-modal"
                      >
                        <svg
                          className="w-5 h-5"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                            clipRule="evenodd"
                          ></path>
                        </svg>
                      </button>
                    </div>
                    {/* <!-- Modal body --> */}
                    <div className="px-6 pb-14 pt-0 text-center">
                      <div className="modal-content max-w-lg mx-auto">
                        <div className="max-w-xs mx-auto">
                          <Image src={'/assets/img/slot-is-taken-illustration.png'} width={2000*.5} height={2000*.5} alt="Slot Is Take Illustration" />
                        </div>
                        <h2>Aw, Sorry!</h2>
                        <h3 className="mb-5 text-lg font-normal">
                          The appointment slot you have selected is already taken. Please select another slot.
                        </h3>

                        <button
                          data-modal-toggle="popup-modal"
                          type="button"
                          onClick={slotFull}
                          className="btn-primary w-3/4 mx-auto p-3 rounded-full"
                        >
                          Book other slot
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
  )
}

export default SlotFullModal